// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2E9LQ","content":"Consent_content__2Tb3p","footer":"Consent_footer__3rm7X"};